import { Injectable } from "@angular/core";
import { FileOpener } from "@ionic-native/file-opener/ngx";
import { File as localFile } from "@ionic-native/file/ngx";
import { UtilService } from "./util.service";
import { HTTP } from "@ionic-native/http/ngx";
import { StaticDataService } from "./static-data.service";
import { Platform } from "@ionic/angular";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Capacitor } from "@capacitor/core";
import { EnumService } from "./enum.service";
import { FileTransfer } from "@ionic-native/file-transfer/ngx";
import { NavController } from "@ionic/angular";
import { pdfViewerObject } from "../_models/pdfViewerObject";
import {FilePath} from "@ionic-native/file-path"

@Injectable({
  providedIn: "root",
})
export class FilehandlerService {
  // Queue for FileReader operations to prevent race conditions
  private fileReaderQueue: Promise<void> = Promise.resolve();

  constructor(
    private navController: NavController,
    private httpClient: HttpClient,
    private fileOpener: FileOpener,
    private platform: Platform,
    private file: localFile,
    public utilService: UtilService,
    public fileTransfer: FileTransfer,
    private http: HTTP,
  ) {

    FilePath

  }
  dedicatedMode =
  localStorage.getItem(EnumService.LocalStorageKeys.IS_DEDICATED_MODE) ===
  "true";

  readJsonFile(filePath, accessID = "") {
    const token = localStorage.getItem(EnumService.LocalStorageKeys.API_TOKEN);

    // Authenticaotion by setting header with token value
    let headers: any = {};
    if (accessID && token) {
      headers = {
        accessID,
        token,
        Accept: "application/json",
      };
    }

    return fetch(filePath, { headers: headers }).then((res) => res.json());
  }

  // saveBinaryFileOnDevice(base64File: string, fileName: string, callBack) {
  //   const extension = fileName.split(".").pop();
  //   const mimeType = StaticDataService.fileMimeTypes[extension.toLowerCase()];

  //   const writeDirectory = this.platform.is("ios")
  //     ? this.file.dataDirectory
  //     : this.file.externalDataDirectory;
  //   try {
  //     this.file
  //       .writeFile(
  //         writeDirectory,
  //         fileName,
  //         UtilService.convertBase64ToBlob(
  //           base64File,
  //           "data:" + mimeType + ";base64"
  //         ),
  //         { replace: true }
  //       )
  //       .then(() => {
  //         callBack(writeDirectory + fileName);
  //       })
  //       .catch(() => {
  //         console.error("Error writing pdf file");
  //         callBack(false);
  //       });
  //   } catch (error) {
  //     callBack(false);
  //   }
  // }

  offlineFilesDirectory = () => {
    return this.file.dataDirectory;
    //return this.file.externalRootDirectory;
  };

  async urlToBase64(url: string): Promise<string | null> {
    try {
        const response = await fetch(url,{
          cache: 'no-store',
          headers: {
              'Cache-Control': 'no-cache, no-store, must-revalidate'
          }
      });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error('Error converting URL to Base64:', error);
        return null;
    }
}

  fetchFileFromUrl(url: string, extension:string): Promise<File> {
    return this.httpClient.get(url, { responseType: 'blob' }).toPromise().then(blob => {
      // Extract file name from URL or generate a new one, create blob
      const fileName = url.split('/').pop() || 'downloaded-file.'+extension;
      const file = new File([blob], fileName, { type: 'application/'+extension });
      return file;
    }).catch(error => {
        console.error('Error fetching file from URL:', error);
        throw error;
    });
  }
  fetchPhotoFromUrl(url: string, extension:string, setName ="", isVideo = false): Promise<File> {
    if (this.platform.is('android') || this.platform.is('ios') || isVideo) {
      const fileName = url.split('/').pop() || `downloaded-file.${extension}`;
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.setRequestHeader('Pragma', 'no-cache')
      if (this.platform.is("android")){
          xhr.setRequestHeader('Cache-Control', 'no-cache');
      } else if (this.platform.is("ios")){
        xhr.setRequestHeader('Cache-Control', 'no-cache, no-store, must-revalidate');
        xhr.setRequestHeader('Expires', '0');
      }
 
      return new Promise((resolve, reject) => {
      xhr.onload = () => {
        if (xhr.status === 200) {
          const blob = xhr.response;
          const objectUrl = URL.createObjectURL(blob);
          //console.log("objectUrl: ", objectUrl)
          try {
            if(this.platform.is("android") || isVideo){
              const mobileManualFile = this.createMobileFile(blob, fileName, `application/jpg`);
              resolve(mobileManualFile);
            } else if (this.platform.is("ios")){
              const mobileManualFile = this.createMobileFile(blob, objectUrl, `application/jpg`);
              resolve(mobileManualFile);
            }
          } catch (error) {
            console.warn("File constructor failed, using fallback:", error);
          }
        } else {
          reject(new Error(`Error fetching file. Status: ${xhr.status}`));
        }
      };
 
      xhr.onerror = () => reject(new Error('Network error occurred.'));
      xhr.send();
    });
    } else {
      return this.httpClient.get(url, { responseType: 'blob' ,headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }
      }).toPromise().then(blob => {
          const fileName = setName !=""? setName : url.split('/').pop() || 'downloaded-file.'+extension;
          const file = new File([blob], fileName, { type: 'application/'+extension });
          return file;
      }).catch(error => {
        console.error('Error fetching file from URL:', error);
        throw error;
      });
    }
  }
  fetchVideoFromUrl(url:string, extension:string): Promise<File>{
    const fileName = url.split('/').pop() || `downloaded-file.${extension}`;
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.setRequestHeader('Pragma', 'no-cache')
      if (this.platform.is("android")){
          xhr.setRequestHeader('Cache-Control', 'no-cache');
      } else if (this.platform.is("ios")){
        xhr.setRequestHeader('Cache-Control', 'no-cache, no-store, must-revalidate');
        xhr.setRequestHeader('Expires', '0');
      }
      return new Promise((resolve, reject) => {
        xhr.onload = () => {
          if (xhr.status === 200) {
            const blob = xhr.response;
            const objectUrl = URL.createObjectURL(blob);
            try { 
                const mobileManualFile = this.createMobileFile(blob, fileName, `application/mp4`);
                resolve(mobileManualFile);
            } catch (error) {
              console.warn("File constructor failed, using fallback:", error);
            }
          } else {
            reject(new Error(`Error fetching file. Status: ${xhr.status}`));
          }
        };
        xhr.onerror = () => reject(new Error('Network error occurred.'));
        xhr.send();
      });
  }
  private createMobileFile(blob: Blob, fileName: string, mimeType: string): File {
    const correctedBlob = new Blob([blob], { type: mimeType });
    const file: File = Object.assign(correctedBlob, {
        name: fileName,
        lastModified: Date.now(),
        lastModifiedDate: new Date(Date.now()),
        webkitRelativePath: "", // Default value
    });
    return file;
}

  removeCapacitorPrefix(url) {
    const prefix = 'capacitor://localhost/_capacitor_file_';
    if (url.startsWith(prefix)) {
    url = url.substring(prefix.length);
  }
  return url;
  }
  
  removeCapacitorPrefixAndroid(url) {
    const prefix1 = 'http://localhost/_capacitor_file_';
    const prefix2 = 'https://localhost/_capacitor_file_';
    const prefix3 = 'file://https://localhost/_capacitor_file_';
  if (url.startsWith(prefix1)) {
    url = url.substring(prefix1.length);   
  }else  if (url.startsWith(prefix2)) {
    url = url.substring(prefix2.length);   
  }
  else  if (url.startsWith(prefix3)) {
    url = url.substring(prefix3.length);   
  }
  console.log("url after prefix removed (2): ", url)
  return url;
}

async saveFileOnDevicePath(base64StringOrFileObject, folderName) {
  //console.log("attempting to save file: ", base64StringOrFileObject.slice(0,100),base64StringOrFileObject.length, folderName)
  return new Promise(async (resolve, reject) => {
      let targetFileName = this.utilService.Uniqueid();
      const writeDirectory = this.offlineFilesDirectory();

      // Create folder if not exist
      try {
          //await this.file.createDir(writeDirectory, folderName, false);
          const dirEntry = await this.file.createDir(writeDirectory, folderName, false);
      } catch (error) { 
          console.log("Error creating folder, it may already exist:", error);
      }
      console.log("locations: ", targetFileName, writeDirectory)

      if (UtilService.IsBase64Sring(base64StringOrFileObject)) {
          // Handle base64 string input
          console.log("file is base64")
          const base64Data = base64StringOrFileObject;
          let extension = "jpeg";
          try {
              extension = base64Data.split(";")[0].split("/")[1];
          } catch (error) { }
          targetFileName += "." + extension;
          const blob = UtilService.convertBase64ToBlob(
              UtilService.FixBase64String(base64Data),
              "image/" + extension
          );
          this.file
              .writeFile(writeDirectory, folderName + "/" + targetFileName, blob)
              .then((res) => {
                  resolve(writeDirectory + folderName + "/" + targetFileName);
              })
              .catch((error) => {
                  reject(error);
              });
      } else if (typeof base64StringOrFileObject === 'object' && base64StringOrFileObject.name && base64StringOrFileObject.type) {  
          // Handle file object input
          console.log("is object:", base64StringOrFileObject)
          const fileObject = base64StringOrFileObject;
          const extension = fileObject.name.split('.').pop();
          targetFileName += "." + extension;
          try {
              const sourceFileName = fileObject.name;
              const sourceDirectory = UtilService.fixDeviceDirPath(
                  base64StringOrFileObject.path.replace(sourceFileName, "")
              );
              console.log("fixed source: ", sourceDirectory)

              this.file
                  .copyFile(
                      sourceDirectory,
                      sourceFileName, 
                      writeDirectory,
                      folderName + "/" + targetFileName
                  )
                  .then((res) => {
                    console.log("conpy result: ", res)
                      resolve(writeDirectory + folderName + "/" + targetFileName);
                  })
                  .catch((error) => {
                      reject(error);
                  });
          } catch (error) {
              reject(error);
          }
      } else {
          // Handle file path input
          console.log("file is path")
          let usedVal = base64StringOrFileObject?.attachement ? base64StringOrFileObject?.attachement : base64StringOrFileObject;
          if (usedVal?.name) { usedVal = usedVal?.name; }
          if (this.platform.is('android')) { 
              usedVal = this.removeCapacitorPrefixAndroid(usedVal);
          } else {
              usedVal = this.removeCapacitorPrefix(usedVal);
          }
          console.log("file val: ", usedVal)
          const extension = usedVal.split(".").pop();
          targetFileName += "." + extension;
          try {
              const sourceFileName = usedVal.split("\\").pop().split("/").pop();
              const sourceDirectory = UtilService.fixDeviceDirPath(
                  usedVal.replace(sourceFileName, "")
              );
              console.log("source file and dir:", sourceFileName, sourceDirectory)

              this.file
                  .copyFile(
                      sourceDirectory,
                      sourceFileName,
                      writeDirectory,
                      folderName + "/" + targetFileName
                  )
                  .then((res) => {
                    console.log("finished copy: ", res)
                      resolve(writeDirectory + folderName + "/" + targetFileName);
                  })
                  .catch((error) => {
                      reject(error);
                  });
          } catch (error) {
              reject(error);
          }
      }
  });
}

  async saveFileOnDevice(path, callBack) {
    console.log('🔵 [SAVE FILE] saveFileOnDevice called with path type:', typeof path, 'path:', path);
    let targetFileName: string = this.utilService.Uniqueid();
    const folderName = StaticDataService.offlineFilesFolderName;
    const writeDirectory = this.offlineFilesDirectory();

    //Create folder if not exist
    try {
      await this.file.createDir(writeDirectory, folderName, false);
    } catch (error) { }

    // Check for base64 data URLs (starts with "data:") or base64 strings
    if (
      (typeof path === 'string' && path.startsWith('data:')) ||
      UtilService.IsBase64Sring(path.dataUrl) ||
      UtilService.IsBase64Sring(path)
    ) {
      console.log('🔵 [SAVE FILE] Detected base64 string or data URL');
      const base64Data = typeof path === 'string' && path.startsWith('data:') 
        ? path 
        : (path.dataUrl || path);
      let extension = "jpeg";
      try {
        // Extract extension from data URL format: "data:mime/type;base64,base64string"
        if (typeof base64Data === 'string' && base64Data.startsWith('data:')) {
          const mimeMatch = base64Data.match(/data:([^;]+)/);
          if (mimeMatch && mimeMatch[1]) {
            extension = mimeMatch[1].split('/')[1] || 'jpeg';
          }
        } else {
          extension = base64Data.split(";")[0].split("/")[1];
        }
      } catch (error) { }

      targetFileName += "." + extension;
      const blob = UtilService.convertBase64ToBlob(
        UtilService.FixBase64String(base64Data),
        "image/" + extension
      );
      this.file
        .writeFile(writeDirectory, folderName + "/" + targetFileName, blob)
        .then((res) => {
          console.log('✅ [SAVE FILE] Base64 file saved successfully:', targetFileName);
          callBack(true, targetFileName);
        })
        .catch((error) => {
          console.error('❌ [SAVE FILE] Base64 file save failed:', error);
          callBack(false, error);
        });
    } else if (typeof path === 'object' && path !== null && (path instanceof File || (path.name && path.type))) {
      // Handle File object input (browser File objects or file objects with name/type)
      console.log('🔵 [SAVE FILE] Detected File object:', {
        isFileInstance: path instanceof File,
        hasName: !!path.name,
        hasType: !!path.type,
        hasPath: !!path.path,
        name: path.name,
        type: path.type
      });
      try {
        const fileObject = path;
        const extension = fileObject.name ? fileObject.name.split('.').pop() : 'pdf';
        targetFileName += "." + extension;

        // If File object has a path property (native file), copy it
        if (fileObject.path) {
          console.log('🔵 [SAVE FILE] File object has path property, copying from:', fileObject.path);
          const sourceFileName = fileObject.name;
          const sourceDirectory = UtilService.fixDeviceDirPath(
            fileObject.path.replace(sourceFileName, "")
          );

          this.file
            .copyFile(
              sourceDirectory,
              sourceFileName,
              writeDirectory,
              folderName + "/" + targetFileName
            )
            .then((res) => {
              console.log('✅ [SAVE FILE] File copied successfully:', targetFileName);
              callBack(true, targetFileName);
            })
            .catch((error) => {
              console.error('❌ [SAVE FILE] File copy failed:', error);
              callBack(false, error);
            });
        } else {
          // Browser File object - convert to base64 using readAsDataURL (more reliable than readAsArrayBuffer)
          // Then process through the existing base64 code path which works for images
          console.log('🔵 [SAVE FILE] Browser File object detected, converting to base64...');
          
          const reader = new FileReader();
          reader.onload = () => {
            console.log('✅ [SAVE FILE] FileReader.onload fired, converting to base64 format');
            try {
              // Extract base64 string from data URL (format: "data:mime/type;base64,base64string")
              const dataUrl = reader.result as string;
              const base64Data = dataUrl.split(',')[1] || dataUrl; // Get base64 part after comma
              
              // Process through existing base64 code path (same as images)
              let extension = "pdf";
              try {
                const mimeMatch = dataUrl.match(/data:([^;]+)/);
                if (mimeMatch && mimeMatch[1]) {
                  extension = mimeMatch[1].split('/')[1] || fileObject.name.split('.').pop() || 'pdf';
                } else {
                  extension = fileObject.name.split('.').pop() || 'pdf';
                }
              } catch (error) { }

              targetFileName += "." + extension;
              const blob = UtilService.convertBase64ToBlob(
                UtilService.FixBase64String(base64Data),
                fileObject.type || 'application/pdf'
              );
              
              console.log('🔵 [SAVE FILE] Writing blob to device, size:', blob.size);
              this.file
                .writeFile(writeDirectory, folderName + "/" + targetFileName, blob)
                .then((res) => {
                  console.log('✅ [SAVE FILE] Browser File written successfully:', targetFileName);
                  callBack(true, targetFileName);
                })
                .catch((error) => {
                  console.error('❌ [SAVE FILE] Browser File write failed:', error);
                  callBack(false, error);
                });
            } catch (error) {
              console.error('❌ [SAVE FILE] Error processing FileReader result:', error);
              callBack(false, error);
            }
          };
          
          reader.onerror = (error) => {
            console.error('❌ [SAVE FILE] FileReader.onerror fired:', error);
            callBack(false, 'Failed to read file');
          };
          
          console.log('🔵 [SAVE FILE] Starting FileReader, reading as DataURL...');
          reader.readAsDataURL(fileObject);
        }
      } catch (error) {
        console.error('❌ [SAVE FILE] Exception in File object handling:', error);
        callBack(false, error);
      }
    } else if (typeof path === 'string') {
      console.log('🔵 [SAVE FILE] Detected string path:', path);
      // Handle string path input
      const extension = path.split(".").pop();
      targetFileName += "." + extension;

      try {
        // Convert Capacitor URL to native file path if needed
        let nativePath = path;
        if (path.startsWith('capacitor://localhost/_capacitor_file_')) {
          // Extract the native file system path from Capacitor URL
          nativePath = path.replace('capacitor://localhost/_capacitor_file_', '');
          console.log('🔵 [SAVE FILE] Converted Capacitor URL to native path:', nativePath);
        } else if (path.startsWith('file://')) {
          // Remove file:// prefix for File plugin operations
          nativePath = path.replace('file://', '');
        }

        const sourceFileName = nativePath.split("\\").pop().split("/").pop();
        const sourceDirectory = UtilService.fixDeviceDirPath(
          nativePath.replace(sourceFileName, "")
        );

        this.file
          .copyFile(
            sourceDirectory,
            sourceFileName,
            writeDirectory,
            folderName + "/" + targetFileName
          )
          .then((res) => {
            console.log('✅ [SAVE FILE] String path file copied successfully:', targetFileName);
            callBack(true, targetFileName);
          })
          .catch((error) => {
            console.error('❌ [SAVE FILE] String path file copy failed:', error);
            callBack(false, error);
          });
      } catch (error) {
        console.error('❌ [SAVE FILE] Exception in string path handling:', error);
        callBack(false, error);
      }
    } else {
      // Unknown type
      console.error('❌ [SAVE FILE] Unknown file type provided:', typeof path, path);
      callBack(false, 'Invalid file type provided');
    }
  }

  removeSavedFile(fileName) {
    try {
      const writeDirectory = this.offlineFilesDirectory();
      this.file.removeFile(writeDirectory, fileName).then((res) => {
        console.log("File removed successfully");
      });
    } catch (error) { }
  }

  removeFile(fileUrl: string) {
    return new Promise((resolve, reject) => {
      try {
        const fileName = fileUrl.split("\\").pop().split("/").pop();
        const directory = fileUrl.replace(fileName, "");

        this.file
          .removeFile(directory, fileName)
          .then((res) => {
            console.log("File removed successfully");
            resolve(res);
          })
          .catch((error) => {
            console.log("File removed error" + JSON.stringify(error));
            reject(error);
          });
      } catch (error) {
        reject(error);
        console.log("File removed error" + JSON.stringify(error));
      }
    });
  }

  removeDirectory(directory: string, directoryName: string) {
    return new Promise((resolve, reject) => {
      try {
        this.file
          .removeRecursively(directory, directoryName)
          .then((res) => {
            console.log("Directory removed successfully");
            resolve(res);
          })
          .catch((error) => {
            console.log("Directory removed error" + JSON.stringify(error));
            reject(error);
          });
      } catch (error) {
        reject(error);
        console.log("Directory removed error" + JSON.stringify(error));
      }
    });
  }

  // saveAndOpenFile(base64File: string, fileName: string) {
  //   this.utilService.presentLoadingWithOptions("Loading...");

  //   this.saveBinaryFileOnDevice(base64File, fileName, (url) => {
  //     this.utilService.hideLoading();

  //     if (url) {
  //       this.openDownloadedFile(url, fileName);
  //     }
  //   });
  // }

  showErrorAlert = (error, defaultErrorMessage = "") => {
    let errorMessage = defaultErrorMessage;
    if (typeof error === "string") {
      errorMessage = error;
    } else if (typeof error === "object" && (error.message || error.error)) {
      if (error.error) {
        errorMessage = error.error;
      } else {
        errorMessage = error.message;
      }
    }
    this.utilService.showAlert(errorMessage, "Alert !");
  };

  async openFile(fileUrl = "", openInDefaultApp = false) {
    if (UtilService.isWebApp()) {
      setTimeout(() => {
        window.open(fileUrl, "__blank");
      }, 10);
    } else {
      this.utilService.presentLoadingWithOptions("File downloading...");

      const fileName = new URL(fileUrl).pathname.split("/").pop();
      this.http
        .downloadFile(fileUrl, {}, {}, this.file.dataDirectory + fileName)
        .then((response) => {
          this.utilService.hideLoading();
          const url = response.nativeURL;
          this.openDownloadedFile(url, fileName, openInDefaultApp);
        })
        .catch((error) => {
          this.utilService.hideLoading();
          this.showErrorAlert(error, "File download error");
          console.log("Error downloading file: ", error);
        });
    }
  }

  openPdfWithViewer(pdfData:pdfViewerObject |any){
    //See /models/pdfViewerObject to see the object names that can/should be sent
    const onError = (error) => {
      this.showErrorAlert(error, "File cannot open");
    };

    if (!pdfData) {
      onError("File not found.");
      return;
    }
    this.navController.navigateForward("/jspdfviewer",{queryParams:{pdfData}})
  }
  
  openPdfInDM(pdfData:pdfViewerObject |any){
    //See /models/pdfViewerObject to see the object names that can/should be sent
    const onError = (error) => {
      this.showErrorAlert(error, "File cannot open");
    };

    if (!pdfData) {
      onError("File not found.");
      return;
    }
    this.navController.navigateForward("/jspdfviewerDM",{queryParams:{pdfData}})
  }

  async openDownloadedFile(url = "", fileName = "", openInDefaultApp = false) {
    const extension = fileName.split(".").pop();

    const onError = (error) => {
      console.error(`❌ [OPEN FILE] Error opening file:`, error);
      console.error(`❌ [OPEN FILE] URL used: ${url}`);
      console.error(`❌ [OPEN FILE] Filename: ${fileName}`);
      this.showErrorAlert(error, "File cannot open");
    };

    if (!url) {
      console.error(`❌ [OPEN FILE] No URL provided for file: ${fileName}`);
      onError("File not found.");
      return;
    }

    console.log(`🔍 [OPEN FILE] Opening file: ${fileName}`);
    console.log(`🔍 [OPEN FILE] URL: ${url}`);
    console.log(`🔍 [OPEN FILE] Extension: ${extension}`);
    console.log(`🔍 [OPEN FILE] Platform: ${this.platform.is("ios") ? "iOS" : "Android"}`);

    // For fileOpener, we need to use the raw file path, not the capacitor:// URL
    // Convert capacitor:// URL back to file:// path if needed
    let filePathToUse = url;
    if (url.startsWith('capacitor://localhost/_capacitor_file_')) {
      // iOS: capacitor://localhost/_capacitor_file_/path → file:///path
      filePathToUse = 'file://' + url.replace('capacitor://localhost/_capacitor_file_', '');
      console.log(`🔍 [OPEN FILE] Converted capacitor:// URL to file:// path: ${filePathToUse}`);
    } else if (url.startsWith('https://localhost/_capacitor_file_')) {
      // Android: https://localhost/_capacitor_file_/path → file:///path
      filePathToUse = 'file://' + url.replace('https://localhost/_capacitor_file_', '');
      console.log(`🔍 [OPEN FILE] Converted https://localhost URL to file:// path: ${filePathToUse}`);
    } else if (!url.startsWith('file://')) {
      filePathToUse = url.startsWith('/') ? `file://${url}` : url;
      console.log(`🔍 [OPEN FILE] Adjusted path: ${filePathToUse}`);
    }

    // Verify file exists before trying to open (for iOS)
    if (this.platform.is("ios") && !UtilService.isWebApp()) {
      try {
        // Extract directory and filename from path
        const pathWithoutFilePrefix = filePathToUse.replace(/^file:\/\//, '');
        const lastSlashIndex = pathWithoutFilePrefix.lastIndexOf('/');
        const directory = pathWithoutFilePrefix.substring(0, lastSlashIndex);
        const filename = pathWithoutFilePrefix.substring(lastSlashIndex + 1);
        
        console.log(`🔍 [OPEN FILE] Verifying file exists...`);
        console.log(`🔍 [OPEN FILE] Directory: ${directory}`);
        console.log(`🔍 [OPEN FILE] Filename: ${filename}`);
        
        const fileExists = await this.file.checkFile(directory, filename);
        if (fileExists) {
          console.log(`✅ [OPEN FILE] File exists, proceeding to open`);
        } else {
          console.error(`❌ [OPEN FILE] File does not exist at expected path`);
          onError({ status: "9", message: "File does not exist" });
          return;
        }
      } catch (checkError) {
        console.warn(`⚠️ [OPEN FILE] Could not verify file existence:`, checkError);
        console.log(`ℹ️ [OPEN FILE] Proceeding anyway - file might still be accessible`);
      }
    }

    const mimeType = StaticDataService.fileMimeTypes[extension.toLowerCase()];
    console.log(`🔍 [OPEN FILE] MIME type: ${mimeType}`);
    console.log(`🔍 [OPEN FILE] Final path to use: ${filePathToUse}`);
    
    if (extension.toLowerCase() === "pdf" || openInDefaultApp) {
      console.log(`🔍 [OPEN FILE] Using fileOpener.open() for PDF`);
      this.fileOpener
        .open(filePathToUse, mimeType)
        .then(() => {
          console.log(`✅ [OPEN FILE] File opened successfully: ${fileName}`);
        })
        .catch((e) => {
          console.error(`❌ [OPEN FILE] fileOpener.open() failed:`, e);
          onError(e);
        });
    } else if (this.platform.is("ios")) {
      console.log(`🔍 [OPEN FILE] Using fileOpener.open() for iOS`);
      this.fileOpener
        .open(filePathToUse, mimeType)
        .then(() => {
          console.log(`✅ [OPEN FILE] File opened successfully: ${fileName}`);
        })
        .catch((e) => {
          console.error(`❌ [OPEN FILE] fileOpener.open() failed:`, e);
          onError(e);
        });
    } else {
      console.log(`🔍 [OPEN FILE] Using fileOpener.showOpenWithDialog() for Android`);
      this.fileOpener
        .showOpenWithDialog(filePathToUse, mimeType)
        .then(() => {
          console.log(`✅ [OPEN FILE] File opened successfully: ${fileName}`);
        })
        .catch((e) => {
          console.error(`❌ [OPEN FILE] fileOpener.showOpenWithDialog() failed:`, e);
          onError(e);
        });
    }
  }
}
